export const ERROR_MESSAGES = {
    INVALID_STATE: 'Please select a valid state',
    INVALID_ZIP_CODE: 'ZIP Code must be 5 digits',
    INVALID_EMAIL: 'Please enter a valid email address',
    INVALID_PHONE: 'Phone number must be 10 digits',
    REQUIRED_FIELD: 'Required*',
    EMAIL_NOT_VERIFIED: 'Please verify your email address before submitting.'
};
